import { DTOModelService, DTO_MODEL_SERVICE } from "@cervval.js/common-dto/src/dtoModel.service";
import { FetchDataConfigurations, FetchDataDefinition, FetchDataFilter, SqlDbDefinition } from "@cervval.js/common-sql-core";
import { injector } from "@cervval.js/common/src/dependencies/injector";
import { keyof } from "@cervval.js/common/src/tools/object.tools";
import { UnixTimestamp } from "@cervval.js/common/src/tools/timestamps.tools.definitions";
import { FieldTypeName, FieldTypes } from "@ehealth_tools/common/src/data/propertyTypes/property.types";
import { ElementTypeName, ElementTypes } from "./global.model";

/** Copycat of the Cjs unexported type */
type FetchDataVariable = {
    name: string,
    varType: keyof FieldTypes,
    mandatory: boolean
}

export enum FetchDataUID {
    GET_ALL = "getAll"
}


/** Params type for the getStatic uid */
export interface FetchDataBaseParams {
    deletionDate?: UnixTimestamp;
    retrieveDeleted?: boolean;
}

export interface FetchDataTypes {
    [FetchDataUID.GET_ALL]: FetchDataBaseParams | undefined;
}
/** Common variables */
const FETCH_DATA_BASE_VARIABLES: FetchDataVariable[] = [
    { name: keyof<FetchDataBaseParams>("deletionDate"), varType: "UnixTimestamp", mandatory: false },
    { name: keyof<FetchDataBaseParams>("retrieveDeleted"), varType: "BOOLEAN", mandatory: false }
];

export const fetchDataConfigurations: FetchDataConfigurations<FieldTypeName> = {
    [FetchDataUID.GET_ALL]: {
        variables: [
            ...FETCH_DATA_BASE_VARIABLES
        ]
    }
};


type GlobalFetchDataDefinition = Record<FetchDataUID, FetchDataDefinition<string, string>>


const DELETION_MARKER_FILTER: FetchDataFilter<string, string> = {
    type: "deletionMarker",
    minDateVariableName: keyof<FetchDataBaseParams>("deletionDate"),
    shouldRetrieveDeletedVariableName: keyof<FetchDataBaseParams>("retrieveDeleted"),
    mandatory: false
};

const EMPTY_DEFINITION: GlobalFetchDataDefinition = {
    [FetchDataUID.GET_ALL]: {
        filters: []
    }
};

/** Set the fetch data config for each tables */
export function injectFetchDataDefinitionsInDbDefinition(dbDefinition: SqlDbDefinition<ElementTypeName>): void {
    const dtoModelService = injector.get<DTOModelService<ElementTypes, FieldTypes>>(DTO_MODEL_SERVICE);
    for (const table of dbDefinition.tables) {
        table.fetchDataDefinitions = EMPTY_DEFINITION;

        const hasArchived = dtoModelService.getTableArchivedField(table.name) != null;
        if (hasArchived) {
            table.fetchDataDefinitions[FetchDataUID.GET_ALL].filters?.push(DELETION_MARKER_FILTER);
        }
    }
}